export function arrayBufferToHexString(buf: ArrayBuffer): string {
	let hexOutput = '';
	const bytes = new Uint8Array(buf);
	for (let i = 0; i < bytes.byteLength; i++) {
		hexOutput += (bytes[i] < 16 ? '0' : '') + bytes[i].toString(16);
	}
	return hexOutput;
}
